module.exports = __webpack_public_path__ + "static/media/07․05.c6e6eb09.webp";